var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconSortZA = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "1.5", strokeMiterlimit: "10" },
            React.createElement("g", { transform: "translate(-412.266 -200.524)" },
                React.createElement("path", { d: "M425.6,220.1l-5.3,5.3l-5.3-5.3" }),
                React.createElement("path", { d: "M420.3,205.8v19.6" })),
            React.createElement("g", { transform: "translate(24.134 1.476)" },
                React.createElement("g", { transform: "translate(5.633 0) rotate(90)" },
                    React.createElement("path", { d: "M11.2,9L2.3,3.9" })),
                React.createElement("path", { d: "M-3.4,11.2H2" }),
                React.createElement("path", { d: "M-3.9,2.3h5.4" })),
            React.createElement("g", { id: "Gruppe_1080", transform: "translate(22.943 15.214)" },
                React.createElement("path", { d: "M-3.9,11l4.2-8.8" }),
                React.createElement("path", { d: "M4.4,11L0.2,2.3" }),
                React.createElement("path", { d: "M-1.9,8.4h4.6" })))));
});
export default IconSortZA;
//# sourceMappingURL=IconSortZA.js.map